import { Alert, Heading, Link, VFlow } from 'bold-ui'
import { useHistory } from 'react-router'

import { NewsModalBodyLinks } from './NewsModalBodyLinks'

type newsModalBodyTypes = {
  handleModalClose?: () => void
}

export function NewsModalBody({ handleModalClose }: newsModalBodyTypes) {
  const history = useHistory()

  const handleOnNovidadesVersaoClicked = () => {
    handleModalClose()
    history.push('/novidades')
  }

  return (
    <>
      <VFlow>
        <Alert type='info' inline>
          <strong>O PEC é frequentemente aprimorado com melhorias e correções!</strong> Para conhecer as próximas
          novidades, o sistema deve ser atualizado com a versão mais recente disponível.
        </Alert>

        <VFlow>
          <Heading level={4}>Novidades:</Heading>
          <NewsModalBodyLinks />
        </VFlow>

        <VFlow>
          <Heading level={4}>Para acessar as Novidades da Versão:</Heading>
          <p>
            No cabeçalho do sistema, abra o menu clicando sobre seu nome e em seguida na opção{' '}
            <Link onClick={handleOnNovidadesVersaoClicked}>Novidades da versão</Link>.
          </p>
          <video
            style={{ width: '100%', height: '250px', objectFit: 'cover', objectPosition: '0 30%', border: 'solid 1px' }}
            src='/static/novidades/modal_notificacao.webm'
            aria-label='Vídeo de como acessar novidades da versão'
            autoPlay
            loop
            muted
            playsInline
          />
        </VFlow>
      </VFlow>
    </>
  )
}
